// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__20une","containerItemsCenter":"Skeleton_containerItemsCenter__3De5M"};